import { CartProductItem } from '@/features/cart/shared/types/cart.types';
import { CurrencyCode } from '@/shared/constants/currencies';
import { CartDataPrice } from '@/shared/types/prices';

export function calculateTotalPrice(items: CartProductItem[]): CartDataPrice {
  let total = 0;
  let currencyCode: string | null = null;

  for (const item of items) {
    if (item.price) {
      total += item.price.value;
      currencyCode = currencyCode || item.price.currencyCode;
    }
  }

  return <CartDataPrice>{
    type: 'total',
    value: total,
    currencyCode: currencyCode || ('USD' as CurrencyCode),
  };
}
